module.exports = __webpack_public_path__ + "components/country-flag/static/fk-123822a0cd9310a0c679962ae88af6a0.svg";